__turbopack_context__.v({
  "canvasContainer": "eqT-TG_canvasContainer",
  "ctaContainer": "eqT-TG_ctaContainer",
  "downloadBtn": "eqT-TG_downloadBtn",
  "mainContent": "eqT-TG_mainContent",
  "primary": "eqT-TG_primary",
  "root": "eqT-TG_root",
  "subtitle": "eqT-TG_subtitle",
});
